type LoadingListener = (isLoading: boolean) => void;
let pendingOperations = 0;
const listeners = new Set<LoadingListener>();
let hideTimer: ReturnType<typeof setTimeout> | undefined;
let visibleSince = 0;
const MIN_VISIBLE_TIME = 650;
const HIDE_GRACE_TIME = 180;
const notify = () => listeners.forEach((listener) => listener(pendingOperations > 0));
const start = () => {
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = undefined; }
  if (pendingOperations === 0) visibleSince = Date.now();
  pendingOperations += 1;
  notify();
};
const stop = () => {
  pendingOperations = Math.max(0, pendingOperations - 1);
  if (pendingOperations > 0) return;
  const elapsed = Date.now() - visibleSince;
  const delay = Math.max(HIDE_GRACE_TIME, MIN_VISIBLE_TIME - elapsed);
  hideTimer = setTimeout(() => {
    hideTimer = undefined;
    if (pendingOperations === 0) notify();
  }, delay);
};
const subscribe = (listener: LoadingListener) => {
  listeners.add(listener);
  listener(pendingOperations > 0);
  return () => {
    listeners.delete(listener);
  };
};
const isLoading = () => pendingOperations > 0;
export const LoadingService = { start, stop, subscribe, isLoading };
